<div class="trg-card-list-item" [class.selected]="selected" [class.selectable]="selectable" [class.no-footer]="!hasFooterContent()">
  <div class="trg-card-list-item-header mb-16" #cardHeaderRef [hidden]="!hasHeaderContent()">
    <ng-content select="[card-header]"></ng-content>
  </div>
  <div class="trg-card-list-item-content pb-8 mb-8" #cardBodyRef [hidden]="!hasBodyContent()">
    <ng-content select="[card-body]"></ng-content>
  </div>
  <div class="trg-card-list-item-footer" #cardFooterRef [hidden]="!hasFooterContent()">
    <ng-content select="[card-footer]"></ng-content>
  </div>
</div>
